module.exports = __webpack_public_path__ + "6144-shadow.41315e6c05bc0d00edf44fc3360157a4.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6144-shadow.png
// module id = 123
// module chunks = 0